import { MediaTileRow } from './MediaTileRow';
import type { VirtualRow } from '../types';

export type MediaContext = {
  tilesPerRow: number;
  onTileClick: (id: string) => void;
};

export function renderVirtualRow(index: number, row: VirtualRow, context: MediaContext) {
  if (row.kind === 'header') {
    return <div className={`text-s-sb text-base-20 pb-2${index > 0 ? ' pt-4' : ''}`}>{row.dateLabel}</div>;
  }
  return <MediaTileRow items={row.items} tilesPerRow={context.tilesPerRow} onTileClick={context.onTileClick} />;
}
